// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AirplaneFilledIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="AirplaneFilledIcon" ref={forwardedRef} {...props}>
      <path d="M8.627 3.662A1 1 0 0 1 8.68 3.34l.397-1.168a.99.99 0 0 1 1.868-.022l.432 1.18a1 1 0 0 1 .061.344v3.441l6.084 3.728A1 1 0 0 1 18 11.695V12.5l-6.562-1.327V15l3.437 3.5h-1.26L10 17.5l-3.644 1H5.125L8.627 15v-3.84L2 12.5v-.805a1 1 0 0 1 .478-.852l6.149-3.767z" />
    </SvgIcon>
  );
});

/**
 * Usage only for within charts
 * @public
 */
export const AirplaneFilledIcon = /* @__PURE__ */ Object.assign(
  AirplaneFilledIconComponent,
  { displayName: 'AirplaneFilledIcon' },
);
